import OnboardingLayout from "layouts/Onboarding";

export default function SearchFactor() {
  return (
    <OnboardingLayout className="flex-1 gap-3.5 pb-6" hideHeader>
      <span className="text-sm text-placeholder">Search Factoring Company</span>
    </OnboardingLayout>
  );
}
